import facetMenu from './facet-menu'

export default {
    facetMenu,
    title: 'Search criteria: ',
    label: 'Search term',
    create: {
        error: {
            search: 'Please enter a search term or choose any of the filters'
        }
    },
    validation: 'Please enter a search word or select facets',
    result: {
        text: 'Based on the selected search query, one micro-trend hit was found in the Trendfinder. | Based on the selected search query, {total} micro-trend hits were found in the Trendfinder.',
        link: 'View all'
    }
}
